module.exports = __webpack_public_path__ + "static/media/avartar2.fac13b9a.jpg";